import React from "react";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";
import { FilterExpander } from "../common/FilterExpander";
import RouteFilter from "./RouteFilter";

const RouteFilterWrapper = () => {
  const { isMobile } = useDeviceLayout();

  return (
    <React.Fragment>
      {isMobile ? (
        <FilterExpander>
          <RouteFilter />
        </FilterExpander>
      ) : (
        <RouteFilter />
      )}
    </React.Fragment>
  );
};
export default RouteFilterWrapper;



// WEBPACK FOOTER //
// ./src/components/RouteStatus/RouteFilterWrapper.js